import { useStyletron } from '@thanx/uikit/theme'
import { GiftCard } from 'api/users'
import Badge from 'components/Badge'
import { buildTranslate } from 'locales'
import React from 'react'
import { merchantTheme } from 'theme'

const t = buildTranslate('users.view.gift_cards.badge')

type PropsT = {
  state: GiftCard['state']
}

const StatusBadge: React.FC<PropsT> = ({ state }) => {
  const [css] = useStyletron()
  let color: string = ''
  let backgroundColor: string = ''

  switch (state) {
    case 'active':
      color = merchantTheme.colors.belizeHole50
      backgroundColor = merchantTheme.colors.belizeHole10
      break
    case 'inactive':
      color = merchantTheme.colors.grey70
      backgroundColor = merchantTheme.colors.grey20
      break
    case 'archived':
      color = merchantTheme.colors.cayenne50
      backgroundColor = merchantTheme.colors.cayenne10
      break
    default:
      break
  }

  const styles = {
    backgroundColor,
    color,
  }

  return <Badge value={t(state)} className={`ml-xs ${css(styles)}`} />
}

export default StatusBadge
